.piaContainer{
    position: absolute;
    bottom: 15px;
    width: 95%;
    text-align: center;
    overflow-y:hidden;
}

.documentData{
  top: 0px;
  margin: auto;
  position: absolute;
}

.documentDataContent{
  display: inline-block;
  vertical-align: middle;
}

.processingText{
  float: right;
}